"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { Home, PieChart, Building2, Settings, Tag, Landmark, List, TrendingUp } from "lucide-react";

export default function BottomNav() {
  const pathname = usePathname();

  const isAuthPage = pathname?.startsWith("/login") || pathname?.startsWith("/register") || pathname?.startsWith("/onboarding");
  if (isAuthPage) return null;

  const links = [
    { href: "/", label: "Overview", icon: Home },
    { href: "/transactions", label: "History", icon: List },
    { href: "/accounts", label: "Accounts", icon: Landmark },
    { href: "/budget", label: "Budget", icon: PieChart },
    { href: "/properties", label: "Properties", icon: Building2 },
    { href: "/investments", label: "Invest", icon: TrendingUp },
    { href: "/categories", label: "Categories", icon: Tag },
  ];

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 flex h-20 w-full items-center justify-around border-t border-border bg-background pb-safe pt-2 md:hidden shadow-[0_-4px_20px_-10px_rgba(0,0,0,0.1)]">
      {links.map((item) => {
        const isActive = pathname === item.href;

        return (
          <Link
            key={item.label}
            href={item.href}
            className={`flex flex-col items-center justify-center space-y-1 w-16 transition-colors ${isActive ? "text-primary" : "text-secondary-foreground/60 hover:text-foreground"
              }`}
          >
            <item.icon className="h-5 w-5" />
            <span className="text-[10px] font-medium">{item.label}</span>
            {isActive && (
              <span className="absolute bottom-1 h-1 w-1 rounded-full bg-primary" />
            )}
          </Link>
        );
      })}
    </nav>
  );
}
